import React, { useState } from 'react';
import { Edit3, Trash2, ChevronDown, ChevronUp } from 'lucide-react';
import { PLATFORMS_CONFIG } from '../configs/constant';
import PostStatusDetail from './PostStatusDetail';
import { apiService } from '../api/apiclient';


const PostCard = ({
    post,
    activeTab,
    selectedDetail,
    setSelectedDetail,
    onDeleteSuccess,
}) => {
    const [showStatusDetail, setShowStatusDetail] = useState(false);
    const isSelected = selectedDetail?.id === post.id;

    const handleDeletePost = (postId) => {
        try {
            apiService.deleteDraft(postId);
            if (onDeleteSuccess)
                onDeleteSuccess(postId);
        } catch (e) {
            console.log(e);
        }
    }

    const handleEditPost = (postId) => {
        window.location.href = `/editor/${postId}`;
    }

    const handleShowFeedPreview = async (externalId, accountId) => {
        try {
            const response = await apiService.getPostFeed(externalId, accountId);
            console.log(response);
            console.log(response.feed);
            if (response.feed?.feed?.permalink) {
                window.open(response.feed.feed.permalink, '_blank');
            }
        } catch (e) {
            console.log(e);
        }
    }
    return (
        <div className={`bg-white border rounded-2xl p-5 shadow-sm transition hover:shadow-md ${isSelected ? 'border-red-500 ring-1 ring-red-500' : 'border-gray-100'
            }`}>
            <div className="flex gap-4">
                {post.thumbnail && (
                    <div className="w-20 h-20 shrink-0 rounded-xl overflow-hidden border border-gray-100 bg-gray-50">
                        <img src={post.thumbnail} alt="preview" className="w-full h-full object-cover" />
                    </div>
                )}

                <div className="flex-1 min-w-0 cursor-pointer" onClick={() => setSelectedDetail(post)}>
                    <p className="text-gray-800 font-medium line-clamp-2 mb-2 leading-relaxed">
                        {post.content || "No content"}
                    </p>
                    <div className="flex items-center gap-3 text-[11px] text-gray-400">
                        <span className="bg-gray-100 px-1.5 py-0.5 rounded font-mono">#{post.id.slice(0, 6)}</span>
                        <span>{new Date(post.created_at).toLocaleString()}</span>
                    </div>
                </div>

                <div className="flex flex-col items-end justify-between ml-2 shrink-0">
                    <div className="flex gap-1.5">
                        {(post.platforms || []).map((p, idx) => {
                            const platformId = typeof p === 'string' ? p : p.name;
                            const config = PLATFORMS_CONFIG[platformId];

                            return (
                                <button
                                    key={idx}
                                    className={`w-7 h-7 rounded-lg flex items-center justify-center text-white text-[10px] transition ${config?.color
                                        } ${activeTab === 'published' ? 'hover:scale-110' : 'opacity-30 grayscale'}`}
                                >
                                    <i className={config?.icon}></i>
                                </button>
                            );
                        })}
                    </div>

                    <div className="flex items-center gap-2 mt-4">
                        {activeTab === 'draft' && (
                            <>
                                <button onClick={(e) => { e.stopPropagation(); handleEditPost(post.id) }} className="p-2 text-gray-400 hover:text-red-500 hover:bg-red-50 rounded-lg transition" title="Edit">
                                    <Edit3 size={18} />
                                </button>
                                <button onClick={(e) => { e.stopPropagation(); handleDeletePost(post.id) }} className="p-2 text-gray-400 hover:text-red-500 hover:bg-red-50 rounded-lg transition" title="Delete">
                                    <Trash2 size={18} />
                                </button>
                            </>
                        )}

                        {activeTab === 'published' && (
                            <button
                                onClick={(e) => { e.stopPropagation(); setShowStatusDetail(!showStatusDetail); setSelectedDetail(post); }}
                                className={`flex items-center gap-1 px-3 py-1.5 rounded-lg text-xs font-bold transition ${showStatusDetail ? 'bg-red-600 text-white' : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                                    }`}
                            >
                                Publishing detail {showStatusDetail ? <ChevronUp size={14} /> : <ChevronDown size={14} />}
                            </button>
                        )}
                    </div>
                </div>
            </div>

            {activeTab === 'published' && showStatusDetail && (
                <PostStatusDetail postId={post.id} onShowFeedPreview={handleShowFeedPreview} />
            )}
        </div>
    );
};

export default PostCard;